import { useState } from "react";
import "./terms_page.css";

export default function TermsComponent({ onAccept }) {
  const [termsAccepted, setTermsAccepted] = useState(false);

  let year = new Date().getFullYear();
  if (year > 2022) year = `2022 - ${year}`;

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setTermsAccepted(checked);
    onAccept?.(checked);
  };

  return (
    <>
      <iframe
        src="/BinLens_EULA.pdf#toolbar=0"
        width="100%"
        height="250px"
        title="PDF Viewer"
        style={{ border: "none" }}
      />

      <div className="terms-actions-setup">
        <label className="terms-checkbox">
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={handleCheckboxChange}
          />
          <span>I have read and agree to the Terms &amp; Conditions</span>
        </label>
      </div>
    </>
  );
}
